import React, {useContext} from 'react';
import {Route, Switch, useHistory, useLocation } from 'react-router-dom';
import AuthScreen from './screens/auth-screen';
import FirebaseContext from "./utils/firebase-context";
import {useRecoilState, useSetRecoilState} from "recoil";
import userState from "./utils/user-state";
import User from "./models/user";
import authLocationState from "./utils/auth-location-state";
import MainApp from "./screens/main-app";

function App() {
  const firebase = useContext(FirebaseContext);
  const setUserState = useSetRecoilState(userState);
  const [authLocation, setAuthLocation] = useRecoilState(authLocationState);
  const history = useHistory();
  const location = useLocation();

  React.useEffect(() => {
    firebase.auth.onAuthStateChanged(async user => {
      if (!user) {
        setUserState(null);
        setAuthLocation(location.pathname);
        history.push("/auth");
        return;
      }
      const doc = (await firebase.getUserForId(user.uid).get()).data() as User;
      setUserState(doc);
      if (location.pathname === "/auth") {
        if (authLocation === "/auth") {
          history.push("/");
        } else {
          history.push(authLocation);
        }

      }
    });
  }, [authLocation, firebase, firebase.auth, history, location.pathname, setAuthLocation, setUserState]);

  return <Switch>
    <Route component={AuthScreen} path={"/auth"} />
    <Route component={MainApp} path={"/"} />
  </Switch>;
}

export default App;
